import switzerlandIcon from "@icons/flags/ic-ch.svg";
import franceIcon from "@icons/flags/ic-fr.svg";
import polandIcon from "@icons/flags/ic-pl.svg";
import belgiumIcon from "@icons/flags/ic-be.svg";
import germanIcon from "@icons/flags/ic-de.svg";
import britishIcon from "@icons/flags/ic-en.svg";
import swedenIcon from "@icons/flags/ic-sw.svg";
import defaultFlag from "@icons/flags/ic-default-flag.png";

export const countryflagIcons = {
  1: britishIcon,
  2: franceIcon,
  3: polandIcon,
  4: belgiumIcon,
  5: franceIcon,
  6: germanIcon,
  7: franceIcon,
  8: switzerlandIcon,
  10: swedenIcon,
};

export const defaultCountryFlag = defaultFlag;
